const classes = ["bg-slate-100"];

export function blinkElement(
  element: HTMLElement,
  customClasses?: string[],
  classesToRemove?: string[]
): void {
  if (classesToRemove && classesToRemove.length > 0) {
    element.classList.remove(...classesToRemove);
  }

  element.classList.add(...(customClasses || classes));

  setTimeout(() => {
    try {
      element.classList.remove(...(customClasses || classes));

      if (classesToRemove && classesToRemove.length > 0) {
        element.classList.add(...classesToRemove);
      }
    } catch (ex) {}
  }, 3000);
}
